import { Link } from "react-router-dom";
import { ArrowRight, MessageCircle } from "lucide-react";
import { Reveal, Typewriter } from "./Reveal";
import { useLang } from "@/i18n/LangContext";
import { waLink, WHATSAPP_MANAGUA } from "@/lib/api";

export default function ManaguaDivider() {
  const { tr } = useLang();
  return (
    <section className="relative py-20 sm:py-28 overflow-hidden bg-gradient-to-bl from-[#04363a] via-[#0B0F12] to-[#0B0F12]" data-testid="managua-divider">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 space-y-10">
        <Reveal from="zoom"><img src="/img/managua-banner.jpg" alt="Nuestra nueva sucursal en Managua – SunCare Dental" className="w-full rounded-[2rem] shadow-[0_30px_80px_rgba(0,201,183,0.2)]" data-testid="managua-divider-img" /></Reveal>
        <Reveal from="right" className="flex flex-col lg:flex-row lg:items-center justify-between gap-6">
          <div>
            <p className="text-xs uppercase tracking-[0.3em] text-[#00C9B7] font-semibold mb-3">Managua · Plaza la Reunión</p>
            <Typewriter className="font-display uppercase text-3xl sm:text-5xl leading-tight">{tr(<>Looking for a dentist in <span className="text-[#00C9B7]">Managua?</span></>, <>¿Buscas dentista en <span className="text-[#00C9B7]">Managua?</span></>)}</Typewriter>
          </div>
          <div className="flex flex-wrap gap-3">
            <Link to="/dentist-managua" className="inline-flex items-center gap-2 rounded-full bg-[#00C9B7] text-[#031312] px-7 py-4 text-xs font-bold uppercase tracking-[0.2em] hover:bg-[#00E0CC] hover:-translate-y-1 transition-[transform,background-color]" data-testid="managua-divider-cta">{tr("Visit our Managua clinic", "Conoce nuestra clínica en Managua")} <ArrowRight size={16} /></Link>
            <a href={waLink(undefined, WHATSAPP_MANAGUA)} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-full bg-[#25D366] text-white px-7 py-4 text-xs font-bold uppercase tracking-[0.2em]" data-testid="managua-divider-whatsapp"><MessageCircle size={16} /> +505 8941 5471</a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
